import React, { useRef } from 'react';
import './RouteCard.css';
import { getGradeColor } from './gradeColors';
import { getAssetUrl } from '../utils/assetUrl';

const RouteCard = ({ route, onClick }) => {
  const wrapperRef = useRef(null);
  const color = getGradeColor(route.difficulty);
  const routeName = route.name || 'Unnamed route';

  return (
    <div
      className="route-card"
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`View ${routeName}`}
    >
      <div className="route-card-color-bar" style={{ background: color }} />
      <div className="route-card-image-wrapper" ref={wrapperRef}>
        <img
          src={getAssetUrl(route.image)}
          alt={routeName}
          className="route-card-image"
        />
      </div>
      <h3>{routeName} - {route.difficulty || 'Unknown grade'}</h3>
      <p>{route.comment || 'No comment'}</p>
    </div>
  );
};

export default RouteCard;
